// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import Vuex from 'vuex'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BMap from 'BMap'
import App from './App'
import router from './router'

import common from './common/common'
import region from './common/region'
import constant from './common/constant'
import menu from './common/menu'
import message from './common/message'

Vue.use(Vuex)
Vue.use(VueCookies)
Vue.prototype.$ajax = axios
Vue.prototype.regionmodule = region
Vue.prototype.constant = constant
Vue.prototype.menumodule = menu
Vue.prototype.message = message
Vue.prototype.common = common

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(BMap)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // router.go(0)
  next()
})



// WEBPACK FOOTER //
// ./src/main.js